import { useState } from 'react';
import { Button, MetaGrid, MetaItem, Panel, ScreenHeader, StateBox } from '@garnet/ui';
import { useAsync } from '../useAsync.js';
import type { PortalApi } from '../data/types.js';
import { ACTIVE_VERTICAL } from '../config/verticals.js';

export function Invitation({ api, onAccept }: { api: PortalApi; onAccept: () => void }) {
  const { data, loading, error } = useAsync(() => api.getInvitation());
  const [accepted, setAccepted] = useState(false);

  if (loading) return <StateBox kind="loading" title="Loading invitation" />;
  if (error || !data) return <StateBox kind="error" title="Could not load the invitation">{error}</StateBox>;

  const V = ACTIVE_VERTICAL;
  return (
    <div className="screen">
      <ScreenHeader
        eyebrow="Invitation"
        title={V.portal_copy.invitation_heading}
        lead={
          <>
            {data.invited_by} has asked Garnet to qualify <strong>{data.supplier}</strong> for{' '}
            {data.asset_summary.toLowerCase()} before purchase. You control what you submit; every document is a claim
            Garnet confirms against the registers.
          </>
        }
      />

      <Panel className="pad">
        <div
          className="eyebrow-sm"
          style={{ paddingBottom: 12, marginBottom: 14, borderBottom: '1px solid var(--rule)' }}
        >
          Diligence request
        </div>
        <MetaGrid labelWidth={130}>
          {data.rows.map(([k, v]) => (
            <MetaItem key={k} label={k}>
              <span style={{ fontFamily: 'var(--mono)', fontSize: 12.5 }}>{v}</span>
            </MetaItem>
          ))}
        </MetaGrid>
      </Panel>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <Button
          variant={accepted ? 'secondary' : 'primary'}
          icon={accepted ? 'check' : 'arrow'}
          disabled={accepted}
          onClick={() => {
            setAccepted(true);
            onAccept();
          }}
        >
          {accepted ? 'Accepted' : 'Accept and submit'}
        </Button>
        <Button variant="ghost">Decline</Button>
      </div>
    </div>
  );
}
